import { mapGetters, mapActions } from 'vuex'

export const authComputed = {
    ...mapGetters('auth', [
        'loggedIn',
        'authToken',
        'tokenExpiresAt',
        'initTime',
        'allowedStores',
        'merchantId',
    ]),
}

export const authMethods = mapActions('auth', ['logIn', 'logOut'])

export const notificationsComputed = {
    ...mapGetters('notifications', ['error', 'info']),
}

export const notificationsMethods = {
    ...mapActions('notifications', ['setError', 'setInfo']),
}

export const storesComputed = {
    ...mapGetters('stores', ['stores', 'selectedStoreId', 'selectedStore']),
}

export const storesMethods = {
    ...mapActions('stores', ['getStores', 'selectStore']),
}

export const purchasesComputed = {
    ...mapGetters('purchases', ['baskets', 'activities']),
}

export const purchasesMethods = {
    ...mapActions('purchases', [
        'getBaskets',
        'updateBasket',
        'createBasket',
        'updateActivities',
        'removeActivities',
        'updateStoreActivity',
        'removeBasket',
        'updateActivity',
        'removeActivity',
    ]),
}

export const customersComputed = {
    ...mapGetters('customers', ['visitors', 'getVisitorByPersonId']),
}

export const customersMethods = {
    ...mapActions('customers', [
        'getStoreVisitors',
        'setVisitor',
        'updateVisitor',
    ]),
}

export const productsComputed = {
    ...mapGetters('products', [
        'categories',
        'products',
        'imagesLinks',
        'getProductById',
        'getCategoryById',
    ]),
}

export const productsMethods = {
    ...mapActions('products', ['getCategories', 'getProducts']),
}

export const streamComputed = {
    ...mapGetters('streams', ['streams']),
}

export const streamMethods = {
    ...mapActions('streams', ['createStream']),
}

export const merchantsMethods = {
    ...mapActions('merchants', ['updateMerchantId', 'getMerchants']),
}

export const merchantsComputed = {
    ...mapGetters('merchants', [
        'selectedMerchantId',
        'isUserMerchantExist',
        'merchants',
        'isStoresActOnBehalfMerchant',
    ]),
}
